import { render, staticRenderFns } from "./FmNoticeDemo.vue?vue&type=template&id=61544eab&scoped=true&"
import script from "./FmNoticeDemo.vue?vue&type=script&lang=js&"
export * from "./FmNoticeDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61544eab",
  null
  
)

export default component.exports